module.exports = __webpack_public_path__ + "img/menu-open.022f3e24.svg";